const consoleError = console.error.bind(console);

export default function noticeError(error) {
  if (window.newrelic && window.newrelic.noticeError) {
    try {
      window.newrelic.noticeError(error);
    } catch (err) {
      consoleError(err);
    }
  }
}

let patched = false;
export function patchNoticeConsoleError() {
  if (patched) {
    return false;
  }

  window.onunhandledrejection = (err) => {
    console.error(err.reason);
  };

  patched = true;
  console.error = (...args) => {
    noticeError(...args);
    consoleError(...args);
  };

  return true;
}



// WEBPACK FOOTER //
// ./src/utils/report.js